import React from 'react';
import OrderDesign from './OrderDesign';

/**
 * Modal to display the revealed enemy order (from Ghost Operative - Unit 295)
 * Shows the order card in the center with an "Acknowledge" button
 */
function RevealedOrderModal({ revealedOrder, enemyId, onAcknowledge }) {
  // Early return if no order to reveal (like CounterStrike dialog)
  if (!revealedOrder) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10000,
      }}
    >
      {/* Title */}
      <div
        style={{
          fontSize: '24px',
          fontWeight: 'bold',
          color: '#FFD700',
          marginBottom: '20px',
          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)',
          textAlign: 'center',
        }}
      >
        👻 Enemy's Next Order Revealed
      </div>

      {/* Order Card Display */}
      <div
        style={{
          transform: 'scale(1.5)',
          marginBottom: '120px', // Increased from 60px to 120px
        }}
      >
        <OrderDesign order={revealedOrder} />
      </div>

      {/* Acknowledge Button */}
      <button
        onClick={onAcknowledge}
        style={{
          padding: '20px 60px', // Increased padding
          fontSize: '20px', // Increased font size
          fontWeight: 'bold',
          backgroundColor: '#4CAF50',
          color: 'white',
          border: '3px solid #fff', // Added white border for visibility
          borderRadius: '8px',
          cursor: 'pointer',
          boxShadow: '0 6px 12px rgba(0, 0, 0, 0.5)', // Stronger shadow
          transition: 'all 0.3s ease',
          marginTop: '20px', // Extra margin for safety
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#45a049';
          e.target.style.transform = 'scale(1.05)';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = '#4CAF50';
          e.target.style.transform = 'scale(1)';
        }}
      >
        Acknowledge
      </button>
    </div>
  );
}

export default RevealedOrderModal;

